(() => {
  const normalize = (value) => (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

  const floatingCart = document.querySelector('[data-floating-cart]');
  const floatingCartPanel = floatingCart?.querySelector('[data-floating-cart-panel]');
  const floatingCartToggle = floatingCart?.querySelector('[data-floating-cart-toggle]');
  const formatMoney = (cents) => `Q${(Number(cents || 0) / 100).toFixed(2)}`;
  const formatMoneyCompact = (cents) => formatMoney(cents).replace(/\.00$/, '');
  const cartConfirmation = document.querySelector('[data-cart-confirmation]');
  const cartConfirmationTitle = cartConfirmation?.querySelector('[data-cart-confirmation-title]');
  const cartConfirmationContinue = cartConfirmation?.querySelector('[data-cart-confirmation-continue]');
  const closeCartConfirmation = () => {
    if (!cartConfirmation) return;
    if (typeof cartConfirmation.close === 'function' && cartConfirmation.open) cartConfirmation.close();
    else cartConfirmation.removeAttribute('open');
    document.body.classList.remove('cart-confirmation-is-open');
  };
  const showCartConfirmation = (form) => {
    if (!cartConfirmation) return;
    const productName = form.closest('[data-product-card]')?.querySelector('h3')?.textContent
      || form.closest('.product-info')?.querySelector('h1')?.textContent
      || 'Tu platillo';
    if (cartConfirmationTitle) cartConfirmationTitle.textContent = `${productName.trim()} está en tu pedido.`;
    cartConfirmation.dataset.context = form.classList.contains('product-form')
      ? 'product'
      : (form.closest('.cart-upsell') ? 'cart-upsell' : 'catalog');
    document.body.classList.add('cart-confirmation-is-open');
    if (typeof cartConfirmation.showModal === 'function') cartConfirmation.showModal();
    else cartConfirmation.setAttribute('open', '');
    cartConfirmation.querySelector('a')?.focus();
  };
  const setFloatingCart = (open) => {
    if (!floatingCartPanel || !floatingCartToggle) return;
    floatingCartPanel.hidden = !open;
    floatingCartToggle.setAttribute('aria-expanded', String(open));
    floatingCart.classList.toggle('is-open', open);
  };
  const renderFloatingCart = (cart) => {
    if (!floatingCart || !cart) return;
    const customerItemCount = cart.items
      .filter((item) => item.handle !== 'order-fees')
      .reduce((total, item) => total + item.quantity, 0);
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = customerItemCount; });
    floatingCart.querySelectorAll('[data-floating-cart-total], [data-floating-cart-subtotal]').forEach((total) => {
      total.textContent = formatMoney(cart.total_price);
    });
    const freeDeliveryThreshold = 25000;
    const productTotal = cart.items
      .filter((item) => item.handle !== 'order-fees')
      .reduce((total, item) => total + item.final_line_price, 0);
    const deliveryProgress = Math.min(100, Math.round((productTotal / freeDeliveryThreshold) * 100));
    const deliveryRemaining = Math.max(0, freeDeliveryThreshold - productTotal);
    const progress = floatingCart.querySelector('[data-floating-cart-progress]');
    const progressFill = floatingCart.querySelector('[data-floating-cart-progress-fill]');
    const progressLabel = floatingCart.querySelector('[data-floating-cart-progress-label]');
    if (progress) progress.setAttribute('aria-valuenow', String(deliveryProgress));
    if (progressFill) progressFill.style.width = `${deliveryProgress}%`;
    if (progressLabel) {
      progressLabel.textContent = productTotal === 0
        ? 'Empieza tu pedido'
        : (deliveryRemaining > 0
          ? `Te faltan ${formatMoneyCompact(deliveryRemaining)} para envío gratis`
          : 'Envío gratis desbloqueado');
    }
    const itemsRoot = floatingCart.querySelector('[data-floating-cart-items]');
    if (!itemsRoot) return;
    itemsRoot.replaceChildren();
    if (!cart.items.length) {
      const empty = document.createElement('p');
      empty.className = 'floating-cart-empty';
      empty.textContent = 'Tu pedido está esperando el primer antojo.';
      itemsRoot.append(empty);
      return;
    }
    const sortedItems = [...cart.items].sort((first, second) =>
      Number(first.handle === 'order-fees') - Number(second.handle === 'order-fees'));
    sortedItems.forEach((item) => {
      const article = document.createElement('article');
      const imageUrl = item.featured_image?.url || item.image;
      if (imageUrl) {
        const image = document.createElement('img');
        image.src = imageUrl;
        image.alt = item.product_title;
        image.loading = 'lazy';
        article.append(image);
      }
      const copy = document.createElement('div');
      const link = document.createElement('a');
      link.href = item.url;
      link.textContent = item.handle === 'order-fees' ? 'Hospitality Fee: 8%' : item.product_title;
      const quantity = document.createElement('small');
      quantity.textContent = `${item.quantity} × ${formatMoney(item.final_price)}`;
      copy.append(link);
      Object.entries(item.properties || {}).forEach(([name, value]) => {
        if (!value || name.startsWith('_')) return;
        const property = document.createElement('small');
        property.className = 'floating-item-property';
        const label = document.createElement('b');
        label.textContent = `${name}: `;
        property.append(label, document.createTextNode(String(value)));
        copy.append(property);
      });
      copy.append(quantity);
      const linePrice = document.createElement('strong');
      linePrice.textContent = formatMoney(item.final_line_price);
      article.append(copy, linePrice);
      itemsRoot.append(article);
    });
  };
  floatingCartToggle?.addEventListener('click', () => setFloatingCart(floatingCartPanel?.hidden !== false));
  floatingCart?.querySelector('[data-floating-cart-close]')?.addEventListener('click', () => setFloatingCart(false));
  cartConfirmation?.querySelectorAll('[data-cart-confirmation-close]').forEach((button) => button.addEventListener('click', closeCartConfirmation));
  cartConfirmation?.addEventListener('click', (event) => {
    if (event.target === cartConfirmation) closeCartConfirmation();
  });
  cartConfirmation?.addEventListener('close', () => document.body.classList.remove('cart-confirmation-is-open'));
  cartConfirmationContinue?.addEventListener('click', () => {
    const context = cartConfirmation?.dataset.context;
    if (context === 'product') {
      window.location.assign(cartConfirmation.dataset.menuUrl || `${window.Shopify.routes.root}collections/menu#platillos`);
      return;
    }
    if (context === 'cart-upsell') {
      window.location.reload();
      return;
    }
    closeCartConfirmation();
  });

  const menu = document.querySelector('#menu-panel');
  const menuTrigger = document.querySelector('.menu-trigger');
  const menuClose = document.querySelector('.menu-close');
  const setMenu = (open) => {
    if (!menu || !menuTrigger) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    menuTrigger.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('menu-is-open', open);
  };
  menuTrigger?.addEventListener('click', () => setMenu(true));
  menuClose?.addEventListener('click', () => setMenu(false));
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setMenu(false);
      setFloatingCart(false);
      closeCartConfirmation();
    }
  });

  document.querySelectorAll('[data-mobile-filter-overlay]').forEach((overlay) => {
    const scope = overlay.parentElement || document;
    const trigger = scope.querySelector('[data-mobile-filter-open]');
    const closeButtons = overlay.querySelectorAll('[data-mobile-filter-close]');
    const close = () => {
      overlay.hidden = true;
      trigger?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('filters-is-open');
      trigger?.focus();
    };
    const open = () => {
      overlay.hidden = false;
      trigger?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('filters-is-open');
      overlay.querySelector('.mobile-filter-sheet>header button')?.focus();
    };
    trigger?.addEventListener('click', open);
    closeButtons.forEach((button) => button.addEventListener('click', close));
    overlay.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      document.body.classList.remove('filters-is-open');
    }));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !overlay.hidden) close();
    });
  });

  document.querySelectorAll('[data-product-grid]').forEach((grid) => {
    const scope = grid.closest('section') || document;
    const cards = [...grid.querySelectorAll('[data-product-card]')];
    const search = scope.querySelector('[data-product-search]');
    const filters = [...scope.querySelectorAll('[data-filter]')];
    const counters = scope.querySelectorAll('[data-result-count]');
    const clearButtons = scope.querySelectorAll('[data-clear-search]');
    const resetButtons = scope.querySelectorAll('[data-reset-filters]');
    const empty = scope.querySelector('[data-empty-results]');
    let active = 'all';
    let shareOnly = false;

    const matchesCategory = (card) => {
      if (active === 'all') return true;
      const haystack = normalize(`${card.dataset.category} ${card.dataset.collections}`);
      const aliases = {
        burgers: ['burger', 'sandwich'],
        wraps: ['wrap', 'burrito', 'shawarma', 'shawerma'],
        ensaladas: ['ensalada', 'sopa', 'bowl'],
        ceviches: ['ceviche'],
        pastas: ['pasta'],
        sushi: ['sushi'],
        postres: ['postre', 'dulce']
      };
      return (aliases[active] || [active]).some((term) => haystack.includes(term));
    };

    const apply = () => {
      const query = normalize(search?.value);
      let visible = 0;
      cards.forEach((card) => {
        const sharing = normalize(`${card.dataset.category} ${card.dataset.collections}`).includes('para compartir');
        const show = (!query || normalize(card.dataset.search).includes(query)) && matchesCategory(card) && (!shareOnly || sharing);
        card.hidden = !show;
        if (show) visible += 1;
      });
      counters.forEach((counter) => { counter.textContent = String(visible); });
      clearButtons.forEach((button) => { button.hidden = !query; });
      resetButtons.forEach((button) => { button.hidden = !query && active === 'all' && !shareOnly; });
      if (empty) empty.hidden = visible !== 0;
    };

    search?.addEventListener('input', apply);
    filters.forEach((button) => button.addEventListener('click', () => {
      const value = button.dataset.filter;
      if (value === 'share') {
        shareOnly = !shareOnly;
        button.classList.toggle('active', shareOnly);
        button.setAttribute('aria-pressed', String(shareOnly));
        button.textContent = `${shareOnly ? '✓' : '+'} Para compartir`;
      } else {
        active = value;
        filters.filter((item) => item.dataset.filter !== 'share').forEach((item) => {
          const selected = item === button;
          item.classList.toggle('active', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
      }
      apply();
    }));
    clearButtons.forEach((button) => button.addEventListener('click', () => { if (search) search.value = ''; apply(); search?.focus(); }));
    resetButtons.forEach((button) => button.addEventListener('click', () => {
      if (search) search.value = '';
      active = 'all'; shareOnly = false;
      filters.forEach((item) => { const selected = item.dataset.filter === 'all'; item.classList.toggle('active', selected); item.setAttribute('aria-pressed', String(selected)); });
      const share = filters.find((item) => item.dataset.filter === 'share'); if (share) share.textContent = '+ Para compartir';
      apply();
    }));
    apply();
  });

  const addProduct = async (form) => {
    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;
    const originalMarkup = button.innerHTML;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Agregando…';
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('No se pudo agregar');
      const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then((result) => result.json());
      renderFloatingCart(cart);
      setFloatingCart(false);
      showCartConfirmation(form);
      button.innerHTML = originalMarkup;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    } catch (error) {
      button.textContent = 'No se pudo agregar';
      setTimeout(() => {
        button.innerHTML = originalMarkup;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }, 1600);
    }
  };

  document.querySelectorAll('.quick-add, .product-form').forEach((form) => form.addEventListener('submit', (event) => {
    event.preventDefault();
    addProduct(form);
  }));

  const cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    const hospitalityBase = Number(cartForm.dataset.hospitalityBase || 0);
    const hospitalityFee = Number(cartForm.dataset.hospitalityFee || 0);
    const expectedHospitalityFee = Math.round(hospitalityBase * 0.08);

    if (hospitalityBase > 0 && hospitalityFee !== expectedHospitalityFee) {
      const signature = `${hospitalityBase}:${hospitalityFee}:${expectedHospitalityFee}`;
      const syncKey = 'boquiteo-hospitality-fee-sync';
      const previousSync = sessionStorage.getItem(syncKey);
      const updateButton = cartForm.querySelector('button[name="update"]');
      const checkoutButton = cartForm.querySelector('button[name="checkout"]');
      const syncStatus = cartForm.querySelector('[data-fee-sync-status]');

      if (syncStatus) syncStatus.hidden = false;
      if (checkoutButton) checkoutButton.disabled = true;

      if (updateButton && previousSync !== signature) {
        sessionStorage.setItem(syncKey, signature);
        updateButton.disabled = true;
        updateButton.textContent = 'Actualizando cargo…';
        window.setTimeout(() => {
          updateButton.disabled = false;
          updateButton.click();
        }, 350);
      } else {
        if (updateButton) updateButton.disabled = false;
        if (checkoutButton) checkoutButton.disabled = cartForm.dataset.minimumOrderMet !== 'true';
        if (syncStatus) syncStatus.textContent = 'Actualiza el pedido para confirmar el Hospitality Fee.';
      }
    } else {
      sessionStorage.removeItem('boquiteo-hospitality-fee-sync');
    }
  }

  document.querySelector('[data-clear-cart]')?.addEventListener('click', async (event) => {
    const button = event.currentTarget;
    if (!window.confirm('¿Quieres vaciar tu pedido?')) return;
    button.disabled = true;
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/clear.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('No se pudo vaciar el pedido');
      window.location.reload();
    } catch (error) {
      button.disabled = false;
      button.querySelector('span').textContent = 'Intenta de nuevo';
    }
  });
})();
